import axios, {AxiosResponse} from "axios";

export default async function getAwsS3FileUrl(key) {
    console.log('getS3ImageUrl',"start")
 // get images from backend
  let response = await axios.post(`${process.env.REACT_APP_API_HOST}/s3/images`, {key})
      .catch((error) => {
        console.log("getS3ImageUrl", error)
      })
    console.log('getS3ImageUrl',response?.data.data.signedUrl)

  // check response is success
  if(response?.status === 200){
      return response?.data.data.signedUrl;
  }

  return "";
}
